import { BeneficiaryCountry, LegalEntityCountry, PayrollStatus } from '@seapoint/server/enums';
import { Inline } from '../../../../design-system/inline/inline';
import { getCountryFlag } from '../../../../utils/get-country-flag';
import { PayrollStatusBadge } from '../payroll-status-badge/payroll-status-badge';

export type PayrollSummaryCardProps = {
  payrollName: string;
  country: BeneficiaryCountry;
  period: string;
  company: string;
  status: PayrollStatus;
};

export const PayrollSummaryCard = ({ payrollName, country, period, company, status }: PayrollSummaryCardProps) => {
  const countryFlag = getCountryFlag(country as unknown as LegalEntityCountry);
  return (
    <Inline space={2} align="center" className="rounded-xl bg-white px-5 py-8">
      {countryFlag && (
        <img src={countryFlag} loading="eager" fetchPriority="high" className="h-5 w-5 rounded-full object-cover" />
      )}
      <span className="text-lg font-medium text-gray-900">{payrollName}</span>
      <span className="text-seapoint-gray-text">•</span>
      <span className="text-seapoint-gray-text">{period}</span>
      <span className="text-seapoint-gray-text">•</span>
      <span className="text-seapoint-gray-text">{company}</span>
      <span className="text-seapoint-gray-text">•</span>
      <PayrollStatusBadge status={status} />
    </Inline>
  );
};
